/* eslint-disable react/no-deprecated */
import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './i18n'
import { Suspense } from 'react'
import axios from 'axios'
import jwt_decode from 'jwt-decode'

const getServicesHeader = () => {
	let servicesHeader = []
	const selectedMicrosite = JSON.parse(localStorage.getItem('selectedMicrosite'))
	const selectedVcf = JSON.parse(localStorage.getItem('selectedVcf'))
	const selectedKiosk = JSON.parse(localStorage.getItem('selectedKiosk'))

	if (selectedMicrosite && selectedVcf && selectedKiosk) {

		let micrositeHeader = []
		selectedMicrosite?.forEach((element) => {
			micrositeHeader.push('MICROSITE_' + element)
		})

		let vcfHeader = []
		selectedVcf?.forEach((element) => {
			vcfHeader.push('VCF_' + element)
		})

		let kioskHeader = []
		selectedKiosk?.forEach((element) => {
			kioskHeader.push('KIOSK_' + element)
		})


		servicesHeader.push(...micrositeHeader, ...vcfHeader, ...kioskHeader)

		if (servicesHeader.length === 0) {
			const token = localStorage.getItem('token')
			const tokenData = jwt_decode(token)

			if (tokenData !== null && tokenData !== undefined && tokenData.length !== 0) {
				tokenData.services.MICROSITE.forEach((element) => {
					micrositeHeader.push('MICROSITE_' + element)
				})

				tokenData.services.VCF.forEach((element) => {
					vcfHeader.push('VCF_' + element)
				})

				tokenData.services.KIOSK.forEach((element) => {
					kioskHeader.push('KIOSK_' + element)
				})

				servicesHeader.push(...micrositeHeader, ...vcfHeader, ...kioskHeader)
			}
		}
	}

	return servicesHeader.toString()
}

axios.interceptors.request.use((config) => {
	const token = localStorage.getItem('token')
	// Do something before request is sent
	config.headers.jwt_token = token

	if(token !== null) {
		config.headers.services = getServicesHeader()
	}

	return config
}, function (error) {
	// Do something with request error
	return Promise.reject(error)
})

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback='Loading...'>
			<App />
		</Suspense>

	</React.StrictMode>,
	document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
